import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../components/CustomComponent.js";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      created_at: "",
      customer_name: "",
      customer_phone: "",
      customer_address: "",
      ref_number: "",
      amount: "0.00",
      amount_deposit: "0.00",
      total_pay: "0.00",
      transaction_list: [],
      remark: ""
    };
  }

  async componentDidMount() {
    loading(false);
        if(params("uid")){
          await this.Get(params("uid"));
          }
    window.print();
  }
  Get = async (uid) => {
    loading(true);
    let [result,result_invoice] = await Promise.all([
      GET("admin/credit-notes/list", {uid}),
      GET("admin/invoices/list", {uid:params("ref_number")}),
    ]);
    if (result?.status) {
      const item = result.data;
      this.setState({
         document_no: item.document_no,
      created_at: item.created_at,
        transaction_list: item.transaction_credit_note || [],
        remark: item.reason || item.remark || "",
      });
    }
    if (result_invoice?.status) {
      const item = result_invoice.data;
      this.setState({
      customer_name: item.sale?.customer?.full_name || "",
      customer_phone: item.sale?.customer?.phone || "",
      customer_address: item.sale?.customer?.address || "",
      ref_number: item.sale?.document_no || "",
      amount: item.sale?.amount,
      amount_deposit: item.sale?.amount_deposit,
      total_pay: item.sale?.total_pay,
      });
    }
    loading(false);
  };
  render() {
    const { document_no,
created_at,
customer_name,
customer_phone,
customer_address,
ref_number,
amount,
amount_deposit,
total_pay,
transaction_list,remark } = this.state;
    return (
      <div
        className="mx-auto bg-white p-5 pdf"
        style={{ width: 1116, height: 1579 }}
      >
        <h1 className="fw-bold text-center mb-3">
          ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่
        </h1>
        <h4 className="fw-bold text-center mb-3">
          61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่
          จ.เชียงใหม่
        </h4>
        <h5 className="fw-bold text-center mb-3">
          โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060
        </h5>
        <h5 className="fw-bold text-center mb-4">
          ทะเบียนการค้าเลขที่ ช.ม. 7820 เลขที่ประจำตัวผู้เสียภาษี 0503543004277
        </h5>
        <h2 className="fw-bold text-center mb-4">ใบลดหนี้</h2>
        <div className="row mb-3">
          <div className="col-6"><h5 className="fw-bold mb-3">เลขที่เอกสาร : {document_no}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">วันที่ : {format_date(created_at,"dd mmmm yyyy","th")}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">ชื่อผู้ซื้อ : {customer_name}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">เบอร์โทร : {customer_phone}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">ที่อยู่ : {customer_address}</h5></div>
          <div className="col-6"><h5 className="fw-bold mb-3">เอกสารอ้างอิง : {ref_number}</h5></div>
        </div>
        <table className="table table-bordered mb-4 text-18">
          <thead>
            <tr className="border-0">
              <td className="fw-bold text-center border-1 wpx-70" rowSpan={2}>
                ลำดับที่
              </td>
              <td className="fw-bold text-center border-1" rowSpan={2}>
                รายการสินค้าหรือบริการ
              </td>
              <td className="fw-bold text-center border-1 wpx-100" rowSpan={2}>
                จำนวนหน่วย
              </td>
              <td className="fw-bold text-center border-1" colSpan={2}>
                ราคาต่อหน่วย
              </td>
              <td className="fw-bold text-center border-1" colSpan={2}>
                มูลค่าสินค้าหรือบริการ
              </td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-center border-1">บาท</td>
              <td className="fw-bold text-center border-1 wpx-40">สต.</td>
              <td className="fw-bold text-center border-1">บาท</td>
              <td className="fw-bold text-center border-1 wpx-40">สต.</td>
            </tr>
          </thead>
          <tbody>
            {transaction_list.filter(e=>Number(e.unit_price) || e.qty).map((item, index) => (
              <tr className="border-0">
                <td className="text-center" style={{ border: "0px 1px" }}>
                  {index + 1}
                </td>
                <td className="text-start" style={{ border: "0px 1px" }}>
                  {item.product_code} {item.product_name}
                </td>
                <td className="text-center" style={{ border: "0px 1px" }}>
                  {item.qty} {item.unit_name}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {toFixed(item.unit_price).split(".")[0]}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {toFixed(item.unit_price).split(".")[1]}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {toFixed(item.unit_price).split(".")[0]}
                </td>
                <td className="text-end" style={{ border: "0px 1px" }}>
                  {toFixed(item.unit_price).split(".")[1]}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-0">
              <td
                className="fw-bold text-end"
                style={{ border: 0, borderTop: "1px solid #000" }}
                colSpan={5}
              >
                มูลค่าสินค้าหรือบริการตามใบกำกับภาษีเดิม
              </td>
              <td className="text-end border-1">{toFixed(amount).split(".")[0]}</td>
              <td className="text-end border-1">{toFixed(amount).split(".")[1]}</td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={5}>
                มูลค่าสินค้าหรือบริการที่ถูกต้อง
              </td>
              <td className="text-end border-1">{toFixed(Number(amount)-total(transaction_list,"unit_price")).split(".")[0]}</td>
              <td className="text-end border-1">{toFixed(Number(amount)-total(transaction_list,"unit_price")).split(".")[1]}</td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={5}>
                ผลต่าง
              </td>
              <td className="text-end border-1">{toFixed(total(transaction_list,"unit_price")).split(".")[0]}</td>
              <td className="text-end border-1">{toFixed(total(transaction_list,"unit_price")).split(".")[1]}</td>
            </tr>
            <tr className="border-0">
              <td className="fw-bold text-end border-0" colSpan={5}>
                จำนวนเงินทั้งสิ้น
              </td>
               <td className="text-end border-1">{toFixed(Number(amount)-total(transaction_list,"unit_price")).split(".")[0]}</td>
              <td className="text-end border-1">{toFixed(Number(amount)-total(transaction_list,"unit_price")).split(".")[1]}</td>
           </tr>
          </tfoot>
        </table>
        <h5 className="fw-bold mb-3">หมายเหตุในการลดหนี้ : {remark || "-"}</h5>
        <div className="d-flex justify-content-around text-center pt-5">
          <div>
            <h5 className="fw-bold mb-4">
              ลงชื่อ.....................................................................................ผู้ตรวจสอบ
            </h5>
            <h5 className="fw-bold mb-4 me-5">
              (..........................................................................................)
            </h5>
            <h5 className="fw-bold mb-4">
              วันที่.................................................................................................
            </h5>
          </div>
          <div>
            <h5 className="fw-bold mb-4">
              ลงชื่อ.....................................................................................ผู้อนุมัติ
            </h5>
            <h5 className="fw-bold mb-4 me-4">
              (..........................................................................................)
            </h5>
            <h5 className="fw-bold mb-4">
              วันที่.................................................................................................
            </h5>
          </div>
        </div>
      </div>
    );
  }
}
